<script setup>
import {onMounted, ref} from 'vue'
import axios from 'axios'

const props = defineProps({
    data: {
        type: Object,
        required: false,
    },
})

onMounted(async () => {
    await getSponsors(sponsorsUrl)
})

const sponsorsUrl = 'api/sponsors'
const sponsors = ref([])
const backEndURL = process.env.VUE_APP_BACKEND_URL

const getSponsors = async url => {
    try {
        const res = await axios.get(`${backEndURL}/${url}`)
        sponsors.value = res.data
    } catch (err) {
        console.error(err)
    }
}

const filterByCategory = (sponsors, category) => {
    return sponsors.filter(sponsor => sponsor.type === category)
}

const linkTo = href => {
    window.open(href, '_blank')
}
</script>

<template>
    <section id="sponsors" class="py-16 bg-gray-50">
        <div class="container px-4 mx-auto">
            <div class="max-w-3xl mx-auto text-center">
                <h1 class="font-heading text-3xl sm:text-4xl mt-2 mb-6 uppercase">SPONSORS</h1>
            </div>

            <div
                v-if="props.data && props.data.our_sponsors_text && props.data.our_sponsors_text.display"
                v-html="props.data.our_sponsors_text.content"></div>

            <!-- INTRODUCTION -->
            <div
                v-if="props.data && props.data.introduction_text.display"
                v-html="props.data.introduction_text.content"></div>

            <!-- MAIN SPONSORS -->
            <div
                v-if="props.data && props.data.main_sponsors_text.display"
                v-html="props.data.main_sponsors_text.content"></div>

            <div
                class="flex flex-col md:flex-row my-4"
                v-for="sponsor in filterByCategory(sponsors, 'MAIN').filter(s => s.display)"
                :key="sponsor.id">
                <img
                    @click="linkTo(sponsor.href)"
                    :src="sponsor.image ? sponsor.image : require('../assets/placeholder.jpg')"
                    class="cursor-pointer block mb-8 mx-auto md:w-1/3 sm:w-1/6 object-scale-down h-75 w-97" />
                <p class="px-4 py-2 md:w-1/2 text-left">
                    {{ sponsor.description }}
                </p>
            </div>

            <!-- APERO SPONSORS -->
            <div
                v-if="props.data && props.data.apero_sponsors_text.display"
                v-html="props.data.apero_sponsors_text.content"></div>
            <div
                class="max-w-3xl mx-auto text-center mt-10"
                v-if="filterByCategory(sponsors, 'APERO').some(s => s.display)">
                <h1 class="font-heading text-3xl sm:text-4xl mt-2 mb-6">
                    {{ $t('sponsors.title_apero') }}
                </h1>
            </div>

            <div
                class="flex flex-wrap -mx-4 -mb-8 justify-center align-center"
                v-for="sponsor in filterByCategory(sponsors, 'APERO').filter(s => s.display)"
                :key="sponsor.id">
                <div class="w-60 sm:w-1/8 xl:w-1/4 px-4 mb-2 mt-8 xl:ml-4 xl:mr-4">
                    <a :href="sponsor.href" target="_blank">
                        <img
                            class="block mb-12 mx-auto object-scale-down h-36 w-38"
                            :src="sponsor.image ? sponsor.image : require('../assets/placeholder.jpg')"
                            :alt="sponsor.name" />
                    </a>
                </div>
            </div>

            <!-- DINNER SPONSORS -->
            <div
                v-if="props.data && props.data.dinner_sponsors_text.display"
                v-html="props.data.dinner_sponsors_text.content"></div>
            <div
                class="max-w-3xl mx-auto text-center mt-10"
                v-if="filterByCategory(sponsors, 'DINNER').some(s => s.display)">
                <h1 class="font-heading text-3xl sm:text-4xl mt-2 mb-6">
                    {{ $t('sponsors.title_dinner') }}
                </h1>
            </div>
            <div
                class="flex flex-wrap -mx-4 -mb-8 justify-center align-center"
                v-for="sponsor in filterByCategory(sponsors, 'DINNER').filter(s => s.display)"
                :key="sponsor.id">
                <div class="w-60 sm:w-1/8 xl:w-1/4 px-4 mb-2 mt-8 xl:ml-4 xl:mr-4">
                    <a :href="sponsor.href" target="_blank">
                        <img
                            class="block mb-8 mx-auto object-scale-down h-36 w-38"
                            :src="sponsor.image ? sponsor.image : require('../assets/placeholder.jpg')"
                            :alt="sponsor.name" />
                    </a>
                </div>
            </div>

            <!-- EXHIBITION SPONSORS -->
            <div
                v-if="props.data && props.data.exhibition_sponsors_text.display"
                v-html="props.data.exhibition_sponsors_text.content"></div>

            <div
                class="flex flex-wrap -mx-4 -mb-8 justify-center align-center"
                v-for="sponsor in filterByCategory(sponsors, 'EXHIBITION').filter(s => s.display)"
                :key="sponsor.id">
                <div class="w-60 sm:w-1/8 xl:w-1/4 px-4 mb-2 mt-8 xl:ml-4 xl:mr-4">
                    <a :href="sponsor.href" target="_blank">
                        <img
                            class="block mb-8 mx-auto object-scale-down h-36 w-38"
                            :src="sponsor.image ? sponsor.image : require('../assets/placeholder.jpg')"
                            :alt="sponsor.name" />
                    </a>
                </div>
            </div>
        </div>
        <div
            class="container mx-auto"
            v-if="props.data && props.data.thank_you_text.display"
            v-html="props.data.thank_you_text.content"></div>
    </section>
</template>

<style scoped></style>
